import React from "react";
import trophy from "../../../assets/images/chpt/trophy.png"
import bannerCard from "../../../assets/images/chpt/banner-card.png";
import winnerImg from "../../../assets/images/chpt/winner-img.jpg";


const CHPTOver = ({users}) => {
  return <div className="chpt-over">
       <div className="gif"> 
       <img src={'https://media.giphy.com/media/26Ff4PUGXu6OgoiWI/giphy.gif'} alt="gif"/>
       </div>
       <h2 className="good-game">good Game</h2>
       <div className="all-users-list">
        <div className="all-users">
            {users?.map((value, key) => (
              <div className="chpt-profile"   >
                <img src={value?.profile_image} alt="profile" />
                <h5 className="name">{value?.display_name}</h5>
              </div>
            ))}
          </div>
       </div>
          
  </div>;

};

export default CHPTOver;
